import { Form, Input, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { addKeyInArray } from "../../../helpers/siteConfig";
import useTable from "../../../hooks/useTable";
import { getAllTowersByBatchPaymentIdAsync } from "../../../store/features/NP/supplier/supplierAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { GetAllTowersByBatchPaymentIdData } from "../../../types/redux/NP/supplier";
import { countParPageSerialNumber } from "../../../utils/number";
import ConfirmModal from "../../common/ConfirmModal";
import CustomTable from "../../common/CustomTable";
import { capitalize } from "lodash";

interface NetworkTableColumn {
  zone: string;
  siteCode: string;
  towerName: string;
  pgName: string;
  teritory: string;
  totalAmount: number;
  missCall: number;
  totalValidRunTime: number;
}

interface BatchPaymentDetailsTableProps {
  verifyOpen: any;
  verifyToggle: () => void;
  rejectOpen?: any;
  rejectToggle: () => void;
  financePaymentOpen?: any;
  financePaymentToggle: () => void;
  approveOpen?: any;
  approveToggle: () => void;
}

export default function BatchPaymentDetailsTable({
  verifyOpen,
  verifyToggle,
  rejectOpen,
  rejectToggle,
  financePaymentOpen,
  financePaymentToggle,
  approveOpen,
  approveToggle,
}: BatchPaymentDetailsTableProps) {
  const { limit, page, handlePagination } = useTable();
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const [selectedData, setSelectedData] = useState<string[]>([]);

  const { getAllTowersByBatchPaymentId, viewLoading } = useAppSelector(
    (state) => state.supplier
  );

  const handlePGStop = (data: any) => {};

  useEffect(() => {
    if (id) {
      dispatch(
        getAllTowersByBatchPaymentIdAsync({
          params: { id },
        })
      );
    }
  }, [dispatch, id]);

  const columns: ColumnsType<GetAllTowersByBatchPaymentIdData> = [
    {
      title: "#SL",
      align: "center" as const,
      width: 60,
      render: (_: unknown, __: unknown, index: number) =>
        countParPageSerialNumber(page, limit, index),
    },
    // {
    //   title: "Site Locator Name",
    //   dataIndex: "tower",
    //   render: (val) => (
    //     <Space className="table_column_title" size={0} direction="vertical">
    //       <h5>{val?.siteCode}</h5>
    //       <p>Tower name: {capitalize(val?.towerName)}</p>
    //     </Space>
    //   ),
    // },
    {
      title: "Zone",
      dataIndex: "areaName",
      align: "center",
      render: (val) => (val ? capitalize(val) : "N/A"),
    },
    {
      title: "Cluster",
      dataIndex: "regionName",
      align: "center",
      render: (val) => (val ? capitalize(val) : "N/A"),
    },

    {
      title: "Site",
      dataIndex: "tower",
      render: (val) => (
        <Space className="table_column_title" size={0} direction="vertical">
          <h5>{val?.siteCode}</h5>
          {/* <p>Tower name: {capitalize(val?.towerName)}</p> */}
        </Space>
      ),
    },

    {
      title: "Tower",
      dataIndex: "tower",
      render: (val) => (
        <Space className="table_column_title" size={0} direction="vertical">
          <h5>{capitalize(val?.towerName)}</h5>
          {/* <p>Tower name: {capitalize(val?.towerName)}</p> */}
        </Space>
      ),
    },
    {
      title: "TT Number",
      dataIndex: "ticketNumber",
      align: "center",
      render: (val) => (
        <Space className="table_column_title" size={0} direction="vertical">
          <h5>{val ? val : "N/A"}</h5>
        </Space>
      ),
    },
    {
      title: "PG Name",
      dataIndex: "pg",
      align: "center",
      render: (val) => `${val?.firstName}`,
    },
    {
      title: "Missed Call",
      dataIndex: "missCall",
      align: "center",
      render: (val) => (val ? "Yes" : "No"),
    },
    {
      title: "Base Amount",
      dataIndex: "totalAmount",
      align: "center",
      render: (val) => (val ? val : 0),
    },
    {
      title: "PGRH",
      dataIndex: "totalValidRunTime",
      align: "center",
      render: (val) => (val ? val : "N/A"),
    },
    // {
    //   title: "Total Amount",
    //   dataIndex: "totalAmount",
    //   align: "center",
    //   render: (val) => (val ? val : 0),
    // },

    {
      title: "Working Hrs",
      dataIndex: "totalValidRunTime",
      align: "center",
      render: (val) => Math.round(val || 0) + " minutes",
    },
  ];

  const loading = false;

  return (
    <>
      {verifyOpen?.type === "VERIFY" && (
        <ConfirmModal
          open={verifyOpen?.open}
          data={verifyOpen?.data}
          handleClose={verifyToggle}
          deleteLoading={loading}
          handleYes={handlePGStop}
          buttonText="Yes, Verify"
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
        >
          <div className="self-stretch justify-start text-zinc-700 text-xl font-semibold ">
            Are You Sure You Want to Payment Request?
          </div>
          <div className="self-stretch justify-start text-zinc-700 text-base font-normal mt-2">
            Are you sure you want to verify? This won’t be undone. After
            clicking these payment goes to the Zonal Admin.
          </div>
        </ConfirmModal>
      )}

      {approveOpen?.type === "APPROVE" && (
        <ConfirmModal
          open={approveOpen?.open}
          data={approveOpen?.data}
          handleClose={approveToggle}
          deleteLoading={loading}
          handleYes={handlePGStop}
          buttonText="Yes, Forward"
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
        >
          <div className="self-stretch justify-start !text-[#2D3643] text-xl font-semibold ">
            Are You Sure You Want to Forward to Finance?
          </div>
          <div className="self-stretch justify-start !text-[#2D3643] text-base font-normal mt-2">
            Are you sure you want to approve those payment? This won’t be
            undone. After clicking these payment goes to the Head of Energy Ops.
          </div>
        </ConfirmModal>
      )}

      {financePaymentOpen?.type === "FINANCE_PAYMENT" && (
        <ConfirmModal
          open={financePaymentOpen?.open}
          data={financePaymentOpen?.data}
          handleClose={financePaymentToggle}
          deleteLoading={loading}
          handleYes={handlePGStop}
          buttonText="Yes, Payment"
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
        >
          <div className="self-stretch justify-start !text-[#2D3643] text-xl font-semibold ">
            Are You Sure, You Want to Payment?
          </div>
          <div className="self-stretch justify-start !text-[#2D3643] text-base font-normal mt-2">
            Are you sure you want to approve those payment? This won’t be
            undone. After clicking these payment goes to the Head of Energy Ops.
          </div>
        </ConfirmModal>
      )}

      {rejectOpen?.type === "REJECT" && (
        <ConfirmModal
          open={rejectOpen?.open}
          data={rejectOpen?.data}
          handleClose={rejectToggle}
          deleteLoading={loading}
          handleYes={handlePGStop}
          buttonText="Yes, Reject"
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
          rejectBtn={true}
        >
          <div className="self-stretch justify-start !text-[#2D3643] text-xl font-semibold ">
            Are You Sure You Want to Reject?
          </div>
          <div className="self-stretch justify-start !text-[#2D3643] text-base font-normal mt-2 mb-3">
            Are you sure you want to reject those payment? This won’t be undone.
          </div>

          <Form layout="vertical">
            <Form.Item label="Tell Us Why?" name="tellUsWhy">
              <Input placeholder="Tell Us Why" />
            </Form.Item>
          </Form>
        </ConfirmModal>
      )}

      <CustomTable<GetAllTowersByBatchPaymentIdData>
        loading={viewLoading ?? false}
        total={10}
        page={page}
        handlePagination={handlePagination}
        columns={columns}
        // dataList={addKeyInArray(allPayment)}
        dataList={
          getAllTowersByBatchPaymentId
            ? addKeyInArray(getAllTowersByBatchPaymentId)
            : []
        }
        // rowSelection={{
        //   type: "checkbox",
        //   selectedRowKeys: selectedData,
        //   onChange: (key) => {
        //     setSelectedData(key as string[]);
        //   },
        //   // getCheckboxProps: (record) => {
        //   //   return {
        //   //     disabled: record?.status === "invited",
        //   //   };
        //   // },
        //   columnWidth: 40,
        // }}
      />
    </>
  );
}
